import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const managerApi = createApi({
  reducerPath: "managerApi",
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    
    fetchUserByManager: builder.query({
      query: () => ({
        url: `/manager/managers/users/`,
        method: 'GET'
      }),
    }),
    
      


    
    
    
  }),
});

// Export hooks for usage in functional components
export const {
    useFetchUserByManagerQuery,
  
  

} = managerApi;

export default managerApi;